import { CssProperties } from "src/models/css-property";
import { ElementStyleService } from "../../../services/element-style.service";
import { IStoreOrderConfirmationWidgetStyle } from "../../../typings/store-order-confirmation-widget-data";

export class StoreOrderConfirmationWidgetStyleRenderer {

    constructor(private readonly styleService: ElementStyleService) {
    }

    public render(element: HTMLElement, style: IStoreOrderConfirmationWidgetStyle): void {
        this.renderCommonStyles(element, style);
        this.renderMainTextStyles(element, style);
        this.renderLinkStyles(element, style);
    }

    private renderCommonStyles(element: HTMLElement, style: IStoreOrderConfirmationWidgetStyle): void {
        const styles = new CssProperties();

        styles.add("--container-border-color", style.containerBorderColor);
        styles.add("--container-background", style.containerBackgroundColor);

        this.styleService.setStyle(element, `#${element.id} .widget-content`, styles.data);
    }

    private renderMainTextStyles(element: HTMLElement, style: IStoreOrderConfirmationWidgetStyle): void {
        const mainTextStyles = new CssProperties();

        if (style.font.color) {
            mainTextStyles.add("color", style.font.color);
        }

        this.styleService.setStyle(element, `#${element.id} .widget-content .main-text`, mainTextStyles.data);
    }

    private renderLinkStyles(element: HTMLElement, style: IStoreOrderConfirmationWidgetStyle): void {
        const defaultStyles = new CssProperties();

        if (style.linkColor.colorDefault) {
            defaultStyles.add("color", style.linkColor.colorDefault);
        }

        this.styleService.setStyle(element, `#${element.id} .widget-content .link`, defaultStyles.data);

        const hoveredStyles = new CssProperties();

        if (style.linkColor.colorHovered) {
            hoveredStyles.add("color", style.linkColor.colorHovered);
        }

        this.styleService.setStyle(element, `#${element.id} .widget-content .link:hover`, hoveredStyles.data);
    }

}
